module.exports = __webpack_public_path__ + "static/media/infinity-icon.72ae37ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infinity-icon.svg
// module id = 155
// module chunks = 0